/** *
 * 获取曝光上报参数
 * report-show="show_{组件名}"
 * report-ext1="{组件顺序}"
 * report-ext2="{组件标题}"
 *  */ export var reportShow = function(array) {
    var reportObj = {
    };
    var showName = array && array[0];
    var ext1 = array && array[1];
    var ext2 = array && array[2];
    var ext3 = array && array[3];
    reportObj['report-show'] = showName;
    reportObj['report-ext1'] = ext1;
    reportObj['report-ext2'] = ext2 || '';
    if (ext3) {
        reportObj['report-ext3'] = ext3;
    }
    return reportObj;
};
